export default [
    {
        path: 'article/list',
        name: 'content_article_list',
        meta: { isCache: true, icon: 'md-paper', hideInMenu: false },
        component: () => import('@/views/content/article/article-list.vue'),
    },
    {
        path: 'article/add',
        name: 'content_article_add',
        meta: { isCache: false, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/content/article/article-add.vue'),
    },
    {
        path: 'article/edit/:id',
        name: 'content_article_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/content/article/article-edit.vue'),
    },
    {
        path: 'article/detail/:id',
        name: 'content_article_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/article/article-detail.vue'),
    },
    {
        path: 'article/history/detail/:id',
        name: 'content_article_history_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/article/article-history-detail.vue'),
    },
    {
        path: 'article/history/list',
        name: 'content_article_history_list',
        meta: { isCache: true, icon: 'md-paper', hideInMenu: true },
        component: () => import('@/views/content/article/article-history-list.vue'),
    },
];
